"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _ref;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _mediaQueries = _interopRequireDefault(require("../../../styles/mediaQueries"));

var _space = _interopRequireDefault(require("../../../styles/space"));

var Wrapper = (0, _styled.default)(_rebass.Flex)((_ref = {
  marginBottom: '2rem'
}, _defineProperty(_ref, _mediaQueries.default.large, {
  marginBottom: _space.default.large
}), _defineProperty(_ref, '&:last-child', {
  marginBottom: '0'
}), _ref));
var _default = Wrapper;
exports.default = _default;